import CryptoJS from 'crypto-js';
import { emitter } from '@/main';
import { permissions_key } from '@/core/constants/LSKeys';
import { Update_Permissions_KEY } from '@/core/constants/EventBusKeys';
import { CRYPTO_KEY } from '../constants/SecretKeys';

export const UpdatePermissions = (permissions: Array<string>) => {
	const encrypt = CryptoJS.AES.encrypt(
		JSON.stringify(permissions),
		CRYPTO_KEY
	).toString();

	localStorage.setItem(permissions_key, encrypt);

	emitter.emit(Update_Permissions_KEY);
};

export const RoleMatch = (allowdPermissions: Array<string>) => {
	try {
		let isMatch = false;
		const decryptedUser = localStorage.getItem(permissions_key);

		const bytes = CryptoJS.AES.decrypt(decryptedUser, CRYPTO_KEY);

		const permissions = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

		if (allowdPermissions.length >= 1) {
			if (
				permissions.filter((perm: string) =>
					allowdPermissions.find((ap) => perm === ap)
				).length > 0
			) {
				isMatch = true;
			} else {
				isMatch = false;
			}
		} else {
			isMatch = false;
		}

		return isMatch;
	} catch (err) {
		return false;
	}
};

export const RemovePermissions = () => {
	localStorage.removeItem(permissions_key);
};

export const isUserHavePermissions = () => {
	try {
		const decryptedUser = localStorage.getItem(permissions_key);

		const bytes = CryptoJS.AES.decrypt(decryptedUser, CRYPTO_KEY);

		const permissions = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

		if (permissions.length > 0) return true;
		else return false;
	} catch (err) {
		return false;
	}
};

export default {
	UpdatePermissions,
	RoleMatch,
	RemovePermissions,
	isUserHavePermissions,
};
